import {
	RealWebSocketTransport, getSharedWebSocketManager, releaseSharedWebSocketManager,
	deriveCmaWsUrl, type EventBus, type WebSocketManagerInstance
} from '@studyportals/ws-client';
import cookieHandler from '@/infrastructure/cookie-handler';

class WsManager {
	private instance: WebSocketManagerInstance | null = null;
	private url: string | null = null;

	/**
	 * Initialises the shared WebSocket manager for this MFE.
	 * Uses getSharedWebSocketManager so multiple bundle copies share one connection.
	 * Call releaseSharedWebSocketManager (via WsManager.release) on teardown.
	 * Idempotent: subsequent calls are no-ops.
	 */
	public initialize(): void {
		if (this.instance) {
			return;
		}

		this.url = deriveCmaWsUrl(webpackDefinitions.CAMPAIGN_MANAGEMENT_API_URL);
		this.instance = getSharedWebSocketManager({
			url: this.url,
			transport: new RealWebSocketTransport(),
			getToken: () => cookieHandler.retrieveTokenIdCookie()
		});
	}

	public getBus(): EventBus {
		if (!this.instance) {
			throw new Error('WsManager.getBus() called before WsManager.initialize()');
		}
		return this.instance.bus;
	}

	public release(): void {
		if (!this.url) {
			return;
		}

		releaseSharedWebSocketManager(this.url);
		this.instance = null;
		this.url = null;
	}
}

export default new WsManager();
